module.exports = __webpack_public_path__ + "img/align-left.a09f86f1.svg";